export default __webpack_public_path__ + "static/media/1080.f4f9f7c8.png";